import React, { createContext, useState, useContext } from 'react';
import util from '@utils/utils';
// 创建Context对象
const StoreContext = createContext();

// Provider组件，用于包裹应用或组件树的一部分
export const StoreProvider = ({ children }) => {
  // 只用 getStorage，不要再 JSON.parse
  // 这样无论老数据还是新数据都能兼容
  const [state, setState] = useState(util.getStorage('policyCompareFiles') || []);

  // 提供修改状态的函数
  const actions = {
    updateValue: (newValue) => {
      setState(newValue);
      util.setStorage('policyCompareFiles', newValue);
    },
  };

  return (
    <StoreContext.Provider value={{ state, actions }}>
      {children}
    </StoreContext.Provider>
  );
};

// useStore自定义Hook，用于在组件中访问store
export const useStore = () => {
  return useContext(StoreContext);
};